import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Message } from 'primeng/api';
import { Contrato } from 'src/app/admihair/api/dto/contrato';
import { ContratoRateio } from 'src/app/admihair/api/dto/contrato-rateio';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { Grupo } from 'src/app/admihair/api/dto/grupo';
import { Subgrupo } from 'src/app/admihair/api/dto/subgrupo';
import { ContratoRateioService } from 'src/app/admihair/service/contrato-rateio.service';
import { ContratoService } from 'src/app/admihair/service/contrato.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { GrupoService } from 'src/app/admihair/service/grupo.service';
import { SubgrupoService } from 'src/app/admihair/service/subgrupo.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AuthUtil } from 'src/app/admihair/util/auth-util';
import { FormatacaoUtil } from 'src/app/admihair/util/formatacao-util';

@Component({
  selector: 'app-contrato-inserir',
  templateUrl: './contrato-inserir.component.html',
  styleUrls: ['./contrato-inserir.component.scss']
})
export class ContratoInserirComponent implements OnInit {

  permissaoInserir: boolean = false;
  messages: Message[] = [];
  empresaSelecionada?: Empresa;
  messagemVisivel: boolean = false;
  fabricanteEncontrado: boolean = false;
  desconto: boolean = false;
  progressoRequisicao: boolean = false;

  contrato: Contrato = {};
  listaGrupos: Grupo[] = [];
  grupoSelecionado: Grupo = {};
  listaRateios: ContratoRateio[] = [];
 

  constructor(private contratoService: ContratoService,
    private grupoService: GrupoService,
    private subgrupoService: SubgrupoService,
    private contratoRateioService: ContratoRateioService,
    private utilStorageService: UtilStorageService,
    private erroService: ErroService) { }

  @ViewChild('f') form?: NgForm;


  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_CONTRATO');
    this.empresaSelecionada = this.utilStorageService.getEmpresa();
    this.carregarGruposServico();
  }

  salvar(){
    this.progressoRequisicao = true;
    this.contrato.razaoSocial = FormatacaoUtil.removerCaracteresEspeciais(this.contrato.razaoSocial);
    this.contrato.empresa = this.empresaSelecionada;
    this.contrato.ativoContratante = true;
    this.contrato.ativoContratado = false;
    this.contrato.tipo = 1;
    this.contrato.excluido = false;
    this.contratoService.salvar(this.contrato).subscribe({
      next: (data: Contrato) => {
        this.salvarRateios(data);
        this.messages = this.erroService.handleSuccess();
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      },
      error: (err: any) => {
        this.messages = this.erroService.handleErro(err);
        this.messagemVisivel = true;
        this.progressoRequisicao = false;
        this.rolarTela();
      }

    });
  }

  salvarRateios(contrato: Contrato){
    this.listaRateios.forEach((rateio: ContratoRateio) => {
      rateio.contrato = contrato
      this.contratoRateioService.salvar(rateio).subscribe({
        next: (data: ContratoRateio) => {
          console.log('rateio salvo:', data);
        },
        error: (err: any) => {
          console.log('erro ao salvar rateio:', err);
        },
      })
    });
    this.limparFormulario();
    this.listaRateios = [];
    
  }

  carregarGruposServico(){
    this.grupoService.listarGruposPorEmpresaECodigoPlanoConta(this.empresaSelecionada?.id, 4).subscribe({
      next: (data: Grupo[]) => {
        this.listaGrupos = data;
      },
      error: (err: any) => {
        console.log('erro ao carregar grupos: ', err);
      }
    })
  }

  adicionarRateio(){
    this.subgrupoService.listarSubgruposPorGrupoId(this.grupoSelecionado.id).subscribe({
      next: (data: Subgrupo[]) => {
        const rateios = data.map((item) => ({
          subgrupo: item,
          percentualRateio: item.rateioBasico
        }));
        for(let r of rateios){
            if(!this.listaRateios.some(rateio => rateio.subgrupo?.id === r.subgrupo.id)){
              this.listaRateios.push(r);
            }
        }
      },
      error: (err: any) => {
        console.log('error:', err);
      }
    })
  }

  excluirRateio(rateio: ContratoRateio){
    const posicao = this.listaRateios.indexOf(rateio);
    this.listaRateios.splice(posicao, 1);
  }

  verificarPermissao(nome: string): boolean{
    return AuthUtil.verificarPermissao(nome);
  }


  ocultarMensagem(){
    if(this.messagemVisivel){
      this.messagemVisivel = false;
    }
  }

  limparFormulario(){
    this.form?.reset(); 
  }

  rolarTela(){
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }
  
  ocultarMsg(){
    this.messagemVisivel = false;
  }
  

}
